import { render, staticRenderFns } from "./CreateGradeModal.vue?vue&type=template&id=19d4bffa&"
import script from "./CreateGradeModal.vue?vue&type=script&lang=js&"
export * from "./CreateGradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports